export default "__VITE_PUBLIC_ASSET__00ad2ad7__"